import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const Title = styled(Text)`
  line-height: 1.6;
  color: #474847;
`;

export const Wrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    > div {
      padding: 0;
    }
  `}
`;
